import { Grid, Typography } from '@mui/material'

import useDates from '../../utils/hooks/useDates'

import useStyles from './index.styles'

const ReturnCard = ({ returnItem }: { returnItem: ReturnItem }) => {
  const classes = useStyles
  const { formatDateTimeShortMonth } = useDates()

  return (
    <Grid container={true} size={12} sx={classes.orderCard}>
      <Grid container={true} sx={classes.orderCardHeader}>
        <Grid container={true} sx={classes.orderDetailsColumn}>
          <Typography variant="overline" sx={classes.orderLabel}>
            Return
          </Typography>
          {returnItem.returnNumber && <Typography variant="body1">#{returnItem.returnNumber}</Typography>}
          <Grid>
            <Typography variant="body2" sx={classes.secondaryText}>
              Updated {formatDateTimeShortMonth(returnItem.lastUpdated)}
            </Typography>
          </Grid>
        </Grid>
        <Typography variant="caption" sx={classes.secondaryText}>
          {returnItem.returnStatus}
        </Typography>
      </Grid>
    </Grid>
  )
}

export default ReturnCard
